// Application
import React, { ReactElement } from 'react'
import QuestionMark from 'assets/question-mark.svg'
import ExclamationMark from 'assets/exclamation-mark.svg'
import { Analytics, ROUTES_PATH } from 'constants/index'

export enum HelpModalInstances {
    recoverPasssword = 'recoverPasssword',
    userWithoutSingleLogin = 'userWithoutSingleLogin',
    accountCipOrphanIsInvalid = 'accountCipOrphan',
    accountFapOrphanIsInvalid = 'accountFapOrphan',
    signupDivergentData = 'signupDivergentData',
    signupDataDontMatch = 'signupDataDontMatch',
    accountCipOrphan = 'accountCipOrphan',
    loginDivergentRegistrationCIP = 'loginDivergentRegistrationCIP',
    loginDivergentRegistrationCPF = 'loginDivergentRegistrationCPF',
    backoffice = 'backoffice',
    dataIncorect = 'dataIncorrect',
}

export interface TrackEventProps {
    event: string
    steps?: string
    path?: string
    reason?: string
    access?: string
}

export interface HelpModalProps {
    displayButton?: boolean
    image: string
    title: string
    subtitle: string | ReactElement
    secondSubtitle?: string
    link?: {
        to: string
        text: string
    }
    showModal: boolean
    trackEvent?: TrackEventProps
    PhonesHelpCenterShow?: boolean
    titleFontSize?: string
}
export const HelpModalData: Record<HelpModalInstances, HelpModalProps> = {
    [HelpModalInstances.recoverPasssword]: {
        image: QuestionMark,
        link: { to: '/login', text: 'Ir para o início' },
        subtitle: 'Entre em contato com o time de atendimento e atualize seus dados pelo telefone:',
        title: 'Não tem mais acesso a estes contatos?',
        showModal: false,
        trackEvent: Analytics.SignUp.SelectContactOpenModal,
    },
    [HelpModalInstances.userWithoutSingleLogin]: {
        image: ExclamationMark,
        subtitle:
            // eslint-disable-next-line max-len
            'Não foi possível recuperar a senha do seu protocolo. Mas não se preocupe! O time de atendimento pode te ajudar, é só entrar em contato pelo telefone:',
        title: 'Encontrei um problema',
        showModal: false,
        displayButton: false,
    },
    [HelpModalInstances.accountCipOrphanIsInvalid]: {
        image: ExclamationMark,
        subtitle:
            // eslint-disable-next-line max-len
            'O CPF e a data de nascimento não coincidem com o que temos em nosso sistema. Tente novamente ou entre em contato com a nossa equipe de ajuda para atualizar suas informações.',
        title: 'Ops, algo está errado!',
        showModal: false,
        displayButton: false,
        trackEvent: Analytics.ActivateAccountCipOrphan.ModalInvalid,
    },
    [HelpModalInstances.accountFapOrphanIsInvalid]: {
        image: ExclamationMark,
        subtitle:
            // eslint-disable-next-line max-len
            'O CPF e a data de nascimento não coincidem com o que temos em nosso sistema. Tente novamente ou entre em contato com a nossa equipe de ajuda para atualizar suas informações.',
        title: 'Ops, algo está errado!',
        showModal: false,
        displayButton: false,
        trackEvent: Analytics.ActivateAccountCipOrphan.ModalInvalidFAP,
    },
    [HelpModalInstances.signupDivergentData]: {
        image: ExclamationMark,
        subtitle:
            // eslint-disable-next-line max-len
            'Os dados informados não coincidem com o que temos em nosso sistema. Tente novamente ou entre em contato com a nossa equipe de ajuda para atualizar suas informações.',
        title: 'Ops, algo está errado!',
        showModal: true,
        displayButton: false,
        trackEvent: Analytics.SignUp.DivergentRegister,
    },
    [HelpModalInstances.signupDataDontMatch]: {
        image: ExclamationMark,
        subtitle:
            // eslint-disable-next-line max-len
            'O CPF e a data de nascimento não coincidem com o que temos em nosso sistema. Tente novamente ou entre em contato com a nossa equipe de ajuda para atualizar suas informações.',
        title: 'Ops, algo está errado!',
        showModal: true,
        displayButton: true,
        link: { to: ROUTES_PATH.SIGN_UP_PERSONAL_DATA, text: 'Revisar dados' },
        trackEvent: Analytics.SignUp.PostalCodeOpenModal,
    },
    [HelpModalInstances.loginDivergentRegistrationCIP]: {
        image: ExclamationMark,
        subtitle:
            // eslint-disable-next-line max-len
            'Não encontrei os resultados pelo seu CPF. Tente usar o número CIP que está no protocolo que o laboratório te entregou no dia do exame, ou fale com a nossa central de ajuda.',
        title: 'Faça login com a sua CIP',
        showModal: false,
        displayButton: false,
        trackEvent: Analytics.SignUp.DivergentRegisterCIP,
    },
    [HelpModalInstances.loginDivergentRegistrationCPF]: {
        image: ExclamationMark,
        subtitle:
            // eslint-disable-next-line max-len
            'Não encontrei os resultados pelo seu CPF. Tente usar o número CIP que está no protocolo que o laboratório te entregou no dia do exame, ou fale com a nossa central de ajuda.',
        title: 'Faça login com a sua CIP',
        showModal: false,
        displayButton: false,
        trackEvent: Analytics.SignUp.DivergentRegisterCPF,
    },
    [HelpModalInstances.backoffice]: {
        image: ExclamationMark,
        subtitle:
            // eslint-disable-next-line max-len
            'Não foi possível recuperar a senha do seu protocolo. Mas não se preocupe! O time de atendimento pode te ajudar, é só entrar em contato pelo telefone:',
        title: 'Encontrei um problema',
        showModal: false,
        displayButton: false,
    },
    [HelpModalInstances.dataIncorect]: {
        image: QuestionMark,
        subtitle: (
            <span>
                Acesse estas{' '}
                <a href="https://ajuda.nav.com.br/hc/pt-br/articles/4416473221005" target="__blanck" title="pagina de ajuda do nav">
                    dúvidas frequentes
                </a>{' '}
                ou entre em contato com o time de atendimento pelo telefone:
            </span>
        ),
        title: 'Precisa de ajuda?',
        showModal: false,
        PhonesHelpCenterShow: true,
        titleFontSize: '32px',
        trackEvent: Analytics.AjudaLogin,
    },
}
